// Vangt fouten op die vallen voordat Sentry geladen is (Sentry komt pas na de
// eerste producten, in een idle-moment). Na de init geeft takeEarlyErrors ze
// door en stoppen we met luisteren; vanaf dan doet Sentry's eigen
// globalHandlers-integratie het werk.

export interface EarlyError {
  error: unknown;
  type: "onerror" | "onunhandledrejection";
}

// Begrensd: een fout in een render-loop mag het geheugen niet volschrijven.
const MAX_EARLY_ERRORS = 20;
const buffer: EarlyError[] = [];

function onError(event: ErrorEvent) {
  push({ error: event.error ?? event.message, type: "onerror" });
}

function onRejection(event: PromiseRejectionEvent) {
  push({ error: event.reason, type: "onunhandledrejection" });
}

function push(early: EarlyError) {
  if (buffer.length < MAX_EARLY_ERRORS) {
    buffer.push(early);
  }
}

export function startEarlyErrorBuffer() {
  if (typeof window === "undefined") return;
  window.addEventListener("error", onError);
  window.addEventListener("unhandledrejection", onRejection);
}

export function takeEarlyErrors(): EarlyError[] {
  if (typeof window !== "undefined") {
    window.removeEventListener("error", onError);
    window.removeEventListener("unhandledrejection", onRejection);
  }
  return buffer.splice(0, buffer.length);
}
